import { useTranslation } from 'react-i18next'
import SelectUniqueIcon, {
    SelectUniqueIconOptions
} from '@/components/_custom/Selector/selectUniqueIcon/selectUniqueIcon'
import TextArea from '@/components/_custom/TextArea/textArea'
import { getOccasionalSlotsIconTextToJSX } from '@/modules/helper/iconsHelper'
import { OccasionalSlotIcon } from '@/types/Slots'
import styles from '../../occasionalSlotForm.module.scss'

interface SlotNoteFieldProps {
    label: string
    value: string
    onChange: (value: string) => void
    iconSelection?: {
        value: OccasionalSlotIcon
        onChange: (value: OccasionalSlotIcon) => void
    }
}

const iconsOptions: SelectUniqueIconOptions[] = Object.values(OccasionalSlotIcon).map((icon) => ({
    title: icon,
    icon: getOccasionalSlotsIconTextToJSX(icon, styles.SelectedIconSize)
}))

export default function SlotNoteField({ label, value, onChange, iconSelection }: SlotNoteFieldProps) {
    const { t } = useTranslation()
    return (
        <div className={styles.TextAreaInput}>
            <p className={styles.TextAreaTitle}>{label}</p>
            {iconSelection && (
                <div className={styles.SelectIcon}>
                    <SelectUniqueIcon
                        icon={getOccasionalSlotsIconTextToJSX(iconSelection.value, styles.SelectedIconSize)}
                        setIcon={(value: string) => iconSelection.onChange(value as OccasionalSlotIcon)}
                        iconsOptions={iconsOptions}
                        title={t('icon')}
                    />
                </div>
            )}
            <TextArea
                placeholder={label}
                className={styles.TextArea}
                value={value}
                onChange={onChange}
                maxCount={100}
            />
        </div>
    )
}
